import { cn, Skeleton } from '@/core/ui';

export function JobItemSkeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'flex flex-col group relative',
        'shrink-0',
        'bg-content1',
        'rounded-lg',
        'border border-default-200',
        'hover:border-default-300',
        'transition-all duration-300',
        'shadow-sm backdrop-blur-xl',
        className,
      )}
    >
      <div className='p-3.5 space-y-3'>
        {/* Header */}
        <div className='flex items-start justify-between'>
          <div className='flex flex-col items-start gap-1 w-full'>
            <div className='flex items-center gap-1'>
              <Skeleton className='size-4 rounded-md' />
              <Skeleton className='h-4 w-28 rounded' />
            </div>
            <Skeleton className='h-2.5 w-5/6 rounded' />
          </div>
          <Skeleton className='h-2 w-5 rounded-md' />
        </div>
        {/* Progress */}
        <div className='mt-1.5'>
          <Skeleton className='w-full h-1.5 rounded max-w-md' />
        </div>
        {/* Info Row */}
        <div className='flex items-center gap-1 my-3'>
          <Skeleton className='h-5 w-20 rounded-lg' />
          <Skeleton className='h-5 w-12 rounded-lg' />
          {/* <Skeleton className='h-4 w-8 rounded' />
          <Skeleton className='h-4 w-8 rounded' /> */}
          <div className='flex-1 flex justify-end'>
            <Skeleton className='h-3 w-16 rounded' />
          </div>
        </div>
        {/* Chips Row */}
        <div className='flex items-center gap-1 mb-2'>
          <Skeleton className='h-5 w-6 rounded-lg' />
          <Skeleton className='h-5 w-6 rounded-lg' />
          <Skeleton className='h-5 w-20 rounded-lg' />
          <div className='flex-1 flex justify-end'>
            <Skeleton className='h-3 w-20 rounded' />
          </div>
        </div>
        {/* Footer: Writer/Editor */}
        <div className='flex items-center gap-1 justify-between'>
          <Skeleton className='h-5 w-24 rounded-md' />
          <Skeleton className='h-5 w-24 rounded-md' />
        </div>
      </div>
    </div>
  );
}
